import React, { useEffect, useState } from "react";
import {
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ViewOrderModel from "app/pages/OrderProcessing/Orders/ViewOrderModel";
import InfoIcon from "@mui/icons-material/Info";
import { useDispatch, useSelector } from "react-redux";
import AllApis from "app/Apis/apis";
import { Axios } from "index";
import Swal from "sweetalert2";
import { formatDate } from "app/pages/Component/Function/formatDate";
import ViewSalesModel from "../ViewSalesModel";
import { getAllSalesOrders } from "app/redux/actions/OrderProcessing/SalesOrders";
import RefundModel from "../Refund/RefundModal";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ViewDispatchModel from "../../Dispatch/ViewDispatchModel";

export default function SalesTable({
  tabletype,
  type,
  page,
  setPage,
  search,
  filter,
  sort,
  setSort,
  sortBy,
  setSortBy,
}) {
  const [openModel, setOpenModel] = useState(false);
  const [refundView, setRefundView] = useState(false);
  const salesOrderData = useSelector(
    (state) => state?.salesOrderReducer?.[type]
  );

  const { TotalPage } = useSelector((state) => state?.salesOrderReducer);
  const { userData } = useSelector((state) => state.userReducer);
  const Permission = userData?.current_data?.role_id?.current_data?.permissions;

  const [orderDetails, setOrderDetails] = useState({});
  const [showmodel, setshowmodel] = useState(false);
  const [refundmodel, setRefundModel] = useState(false);

  const dispatch = useDispatch();
  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "refund":
        setOrderDetails(menuItem?.data);
        setRefundModel(true);
        setRefundView(false);

        break;
      case "view":
        setOpenModel(true);
        setOrderDetails(menuItem?.data?.current_data);
        break;
      case "view_refund":
        setOrderDetails(menuItem?.data?.current_data?.refund_id);
        setRefundModel(true);
        setRefundView(true);
        break;
      case "create_dispatch":
        createDispatch(menuItem?.data?._id);
        break;
      case "view_dispatch":
        setOrderDetails(
          menuItem?.data?.current_data?.dispatch_id?.current_data
        );
        setshowmodel(true);
        break;
      default:
      // navigate(`/dashboard/users`);
    }
  };

  const handleSort = (property) => {
    setSort(sort == "asc" ? "desc" : "asc");
    setSortBy(property);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const changeStatus = async (e, row) => {
    try {
      const response = await Axios.patch(AllApis.order.status(row._id), {
        status: e.target.value,
      });
      if (response) {
        Swal.fire({
          title: "Updated",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        // dispatch(getAllOrders("", sort, sortBy, page, type));
      }
    } catch (error) {
      Swal.fire({
        title: error.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    }
  };

  const createDispatch = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Create Dispatch",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await Axios.post(AllApis.dispatch.add, {
            sales_order_id: id,
          });
          if (response) {
            dispatch(getAllSalesOrders("", "desc", "created_at", 1, type, {}));
            Swal.fire({
              title: "Dispatch Created",
              icon: "success",
              timer: 1000,
              showConfirmButton: false,
            });
            // dispatch(getAllOrders("", sort, sortBy, page, type));
          }
        } catch (error) {
          Swal.fire({
            title: error.message,
            icon: "error",
            timer: 1000,
            showConfirmButton: false,
          });
        }
      }
    });
  };
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: "#7352C7", color: "white" }}>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "160px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.sales_order_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Sales Order No
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Sales Order Date
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "120px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.order_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Order No
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "160px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort("current_data.customer_details.customer_name")
                }
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                {tabletype}
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort("current_data.customer_details.bill_to.gst_no")
                }
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                GST No
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort(
                    "current_data.customer_details.bill_to.address.city"
                  )
                }
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                City
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort(
                    "current_data.customer_details.bill_to.address.state"
                  )
                }
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                State
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.total_weight")}
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Total Weight
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.total_amount")}
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Totol Amount
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
                color: "white",
                position: "sticky",
                right: 0,
                height: "58px",
                zIndex: 1,
                bgcolor: "#7352C7",
              }}
            >
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {salesOrderData?.map((row, i) => {
            return (
              <TableRow key={row._id}>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.sales_order_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {formatDate(row?.current_data?.sales_order_date)}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.order_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.customer_name}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.gst_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.address?.city}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.address?.state}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.total_weight}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  ₹ {row?.current_data?.total_amount?.toFixed(2)}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                    position: "sticky",
                    right: 0,
                    zIndex: 1,
                    bgcolor: "white",
                  }}
                >
                  <JumboDdMenu
                    icon={<MoreHorizIcon />}
                    menuItems={[
                      {
                        icon: <VisibilityRoundedIcon />,
                        title: "View Sales Order",
                        action: "view",
                        data: row,
                        visibility: Permission?.["salesOrder"]?.["view"],
                      },
                      {
                        ...(row?.current_data?.refund_id == null
                          ? {
                              icon: <AccountBalanceWalletIcon />,
                              title: "Refund",
                              action: "refund",
                              data: row,
                              visibility: Permission?.["refund"]?.["add"],
                            }
                          : {
                              icon: <InfoIcon />,
                              title: "View Refund Details",
                              action: "view_refund",
                              data: row,
                              visibility: Permission?.["refund"]?.["view"],
                            }),
                      },
                      {
                        ...(row?.current_data?.dispatch_id == null
                          ? {
                              icon: <AddCircleOutlineIcon />,
                              title: "Generate Dispatch Order",
                              action: "create_dispatch",
                              data: row,
                              visibility: Permission?.["dispatch"]?.["add"],
                            }
                          : {
                              icon: <InfoIcon />,
                              title: "View Dispatch Details",
                              action: "view_dispatch",
                              data: row,
                              visibility: Permission?.["dispatch"]?.["view"],
                            }),
                      },
                    ].filter((ele) => ele.visibility == true)}
                    onClickCallback={handleItemAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        {/* {openModel && <ViewOrderModel open={openModel} setOpen={setOpenModel} rowdata={orderDetails} />} */}

        {openModel && (
          <ViewSalesModel
            open={openModel}
            setOpen={setOpenModel}
            selectedRow={orderDetails}
            setSelectedRow={setOrderDetails}
          />
        )}
        {showmodel && (
          <ViewDispatchModel
            open={showmodel}
            setOpen={setshowmodel}
            selectedRow={orderDetails}
            setSelectedRow={setOrderDetails}
          />
        )}

        {refundmodel && (
          <RefundModel
            open={refundmodel}
            setOpen={setRefundModel}
            selectedRow={orderDetails}
            type={type}
            view={refundView}
          />
        )}
      </Table>
      <Pagination
        count={TotalPage || 1}
        page={page}
        onChange={handleChangePage}
        sx={{
          position: "sticky",
          bottom: 0,
          left: 0,
          p: 1,
          backgroundColor: "white",
          borderTop: "1px solid #ddd",
        }}
      />
    </TableContainer>
  );
}
